exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".monitor-empty .text[data-v-62377126]{margin-top:10px;text-align:center;color:var(--secondButtonDisabled);font-weight:500}", ""]);

// exports
